module.exports = __webpack_public_path__ + "static/media/1.438f88ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/world-allergy-day-2017/1.jpg
// module id = 659
// module chunks = 0